"use client";
import React from "react";
const Title = ({ heading, subText, color, subTextColor, align, className, ...rest }) => {
  const mergedClass = `${className ? className + " " : ""}w-full ${align} md:w-[85%] lg:w-[70%] `;
  return (
    <div className={mergedClass}>
      <h2 {...rest} className={`font-saansBold ${color} text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] mb-2`}>
        {heading}
      </h2>
      {subText && (
        <p {...rest} className={`${subTextColor} text-[16px] md:text-[18px]`}>
          {subText}
        </p>
      )}
    </div>
  );
};

export default Title;
